/**
 * Created by mac on 12/24/20
 */

const ComponentsFactory = function (res, unit, options) {
    const data = unit.getData();

    if (options.grounded) {
        res.push(new Grounded(unit));
    }

    if (options.reward) {
        res.push(new FieldReward(unit, options));
    }

    res.push(new MergeComponent(unit));

    if (data.lockable) {
        res.push(new LockedComponent(unit, options));
    }

    if (data.collectible) {
        res.push(new Collectible(unit));
    }

    if (data.generator) {
        res.push(new Merge2Generator(unit, options));
    }

    if (data.thirdelement) {
        res.push(new ThirdElement(unit, options));
    }

    if (data.cup) {
        res.push(new CupComponent(unit, options));
    }

    if (data.choose) {
        res.push(new ChooseLineComponent(unit, options));
    }

    if (data.rainbow) {
        res.push(new RainbowComponent(unit));
    }

    if (data.scissors) {
        res.push(new ScissorsComponent(unit, options));
    }

    Object.keys(GeneratorBoosterComponent.TYPES).forEach((type) => {
        if (data[type]) {
            res.push(new GeneratorBoosterComponent(unit, type));
        }
    });

    if (data.pin) {
        res.push(new PinComponent(unit));
    }

    if (data.hourglass) {
        res.push(new HourglassComponent(unit));
    }
};